import React from 'react';
// @ts-ignore
import moment from 'moment';
import MediaViewerDisplayImage from './MediaViewerDisplayImage';
import MediaViewerDisplayPdf from './MediaViewerDisplayPdf';
import MediaViewerDisplayNone from './MediaViewerDisplayNone';
import useTranslation from '../../../Hooks/useTranslation';
import LinkButton from '../../BaseModule/Components/Button/LinkButton/LinkButton';

interface MediaViewerProps {
	file: PreviewFile;
	onSuccess?: () => void;
	params?: any;
}

export interface PreviewFile {
	id: string;
	preview: string;
	download: string;
	displayName: string;
	type: string;
}

export default function MediaViewer(props: MediaViewerProps) {
	const { file, params, onSuccess } = props;
	const { t } = useTranslation();

	if (!file) {
		return <></>;
	}

	const handlePrint = async () => {
		// @ts-ignore
		var pdfFrame = window.frames[0];
		pdfFrame.focus();
		pdfFrame.print();
	};

	return (
		<div style={{ height: '100%' }}>
			<div className='row'>
				<div className='col-6'>
					{file.type === 'image' && (
						<div className='d-flex align-items-center gap-2'>
							<div className='pr-2'>
								<img src='/dist/icons/zoom.svg' alt='zoom icon' />
							</div>
							<div className='text-gray pt-2' style={{ fontSize: '16px' }}>
								{t('component.mediaViewer.imageCanBeZoomed')}
							</div>
						</div>
					)}
				</div>
				<div className='col-6 text-right'>
					<div className='d-flex justify-content-end flex-row'>
						{file.type === 'pdf' && false && (
							<>
								<LinkButton
									text='base.printWindow.title'
									onClick={handlePrint}
									theme='purple'
								/>
								<span className='mr-3' />
							</>
						)}
						<LinkButton
							href={file.download}
							text='component.mediaViewer.downloadDocument'
							theme='purple'
						/>
					</div>
				</div>
			</div>
			{file.type === 'image' && <MediaViewerDisplayImage file={file} />}
			{file.type === 'pdf' && <MediaViewerDisplayPdf file={file} />}
			{file.type === 'none' && <MediaViewerDisplayNone file={file} />}
		</div>
	);
}
